export default __webpack_public_path__ + "static/media/1.5f626be0.jpeg";